(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arly-editorial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-arly-video] button');
    if (!trigger) return;
    const frame = trigger.closest('[data-arly-video]');
    const url = new URL(frame.dataset.embed);
    if (url.protocol !== 'https:' || url.hostname !== 'www.tiktok.com' || !url.pathname.startsWith('/player/v1/')) return;
    const iframe = document.createElement('iframe');
    iframe.src = url.href;
    iframe.title = frame.dataset.title;
    iframe.allow = 'fullscreen; encrypted-media';
    iframe.allowFullscreen = true;
    iframe.className = 'arly-video-player';
    trigger.replaceWith(iframe);
    iframe.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
